import { createIdSlice } from '../utils/action/createElementSlice';
export const LayerVisibilityState = createIdSlice({
    elementName: 'layerVisibility',
    initialState: {},
    reducers: {
        /**
         * Sets LayerVisibilityState. Setting undefined deletes any existing state.
         */
        set(_state, action) {
            return action.payload.data;
        },
        /**
         * Indicates the user has toggled a layer's visibility on or off.
         */
        notifyToggleLayerVisibility(state, _action) {
            return state;
        },
    },
});
